import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    customers: [],
    loading: false,
    error: null,
};

const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setCustomers: (state, action) => {
            state.customers = action.payload;
        },
        addCustomer: (state, action) => {
            state.customers.push(action.payload);
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setCustomers, addCustomer, setLoading, setError } = customerSlice.actions;
export default customerSlice.reducer;
